import React from 'react';

import AvatarLetter from '@/components/mui/AvatarLetter';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ChipMui from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Tooltip from '@/components/mui/Tooltip';

import WhatsApp from '@mui/icons-material/WhatsApp';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material';

const Chip = styled(ChipMui)(({ theme }) => ({
  // by design, cant use spacing or pxToRem :(
  height: 18,
  borderRadius: 4,
  fontSize: 12,
  backgroundColor: alpha(theme.palette.primary.main, 0.12),

  '& .MuiChip-icon': {
    fontSize: 16,
  },
  '& .MuiChip-label': {
    direction: 'ltr /* @noflip */',
  },
}));

const Title = styled(Typography)(() => ({
  // by design, cant use spacing or pxToRem :(
  lineHeight: 1,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

const AppBarLogoBase = ({ src, name, email, phone, isAllowPhoneLink = false }) => (
  <Box display="flex" alignItems="center" maxWidth="100%">
    <AvatarLetter src={src} name={name} />
    {/* minWidth:0 lets this flex item shrink below its content so the ellipsis can engage — a flex
        item defaults to min-width:auto and would otherwise push past the parent's maxWidth instead
        of truncating. The cap itself lives in the consuming layout (LayoutCompany caps it at 400px),
        so consumers without a cap are unaffected. */}
    <Box ml={1.5} minWidth={0} whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
      <Tooltip t={name}>
        <Title variant="subtitle1">{name}</Title>
      </Tooltip>
      {(email || phone) && (
        <Stack direction="row" spacing={1} marginTop="6px">
          {email && (
            <Chip
              clickable
              color="primary"
              variant="outlined"
              icon={<EmailOutlinedIcon />}
              label={email}
              component="a"
              href={`mailto:${email}`}
            />
          )}
          {phone && (
            <Chip
              clickable={isAllowPhoneLink}
              color={isAllowPhoneLink ? 'primary' : 'default'}
              variant="outlined"
              icon={<WhatsApp />}
              label={phone}
              {...(isAllowPhoneLink && {
                component: 'a',
                href: `https://api.whatsapp.com/send?phone=${phone}`,
                target: '_blank',
                rel: 'noopener noreferrer',
              })}
            />
          )}
        </Stack>
      )}
    </Box>
  </Box>
);

export default AppBarLogoBase;
